import React from 'react';
import Svg from "../Svg";

const TrackTypeSleighIcon = () => (
	<Svg width="30px" height="30px" viewBox="30 30">
		<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g transform="translate(-25.000000, -682.000000)">
				<g transform="translate(25.000000, 682.000000)">
					<rect stroke="#E6A6F3" strokeWidth="3" fill="#BD10E0" x="1.5" y="1.5" width="27" height="27" rx="13.5"/>
					<g transform="translate(7.503725, 9.324780)">
						<path
							d="M0,9.30853715 L12.618125,9.30853715 C14.5303438,9.30853715 16.0805937,7.7586934 16.0805937,5.84647465 L16.0805937,5.2488809"
							id="Stroke-1" stroke="#FFFFFF" strokeLinejoin="round"/>
						<line x1="2.8312375" y1="5.46423403" x2="2.8312375" y2="9.07498403" id="Stroke-3" stroke="#FFFFFF"
									strokeLinejoin="round"/>
						<line x1="11.0612125" y1="5.46423403" x2="11.0612125" y2="9.07498403" id="Stroke-5" stroke="#FFFFFF"
									strokeLinejoin="round"/>
						<path
							d="M2.29015793,0.580770081 C3.69921487,0.580770081 5.03577067,1.19391821 5.95392775,2.25613167 L6.04433598,2.36384383 L8.34578404,4.79453708 L12.9907829,4.79494333 L12.9907829,6.14558258 L0.820751676,6.14558258 C0.612412117,6.14558258 0.440701892,5.98875375 0.417234817,5.78670991 L0.414501676,5.73933258 L0.414501676,0.987020081 C0.414501676,0.778680522 0.571330504,0.606970297 0.773374344,0.583503222 L0.820751676,0.580770081 L2.29015793,0.580770081 Z"
							fill="#FFFFFF" fillRule="nonzero"/>
					</g>
				</g>
			</g>
		</g>
	</Svg>
);

export default TrackTypeSleighIcon;
